import { formatFileSize } from "@certn/utils";

import { FileInfo } from "./utils";
import { Text } from "../../../foundations/typography/Text";
import { FileUploadPropsPartial } from "../types";

interface Props {
  file: FileInfo;
  fileInfo: FileUploadPropsPartial["showFileInfo"];
}

export function FileSubtitleRAC(props: Props) {
  const { file, fileInfo } = props;

  if (file.subtitle) {
    return <Text color="text-weak">{file.subtitle}</Text>;
  }

  if (fileInfo === "size") {
    return <Text color="text-weak">{formatFileSize(file.size, 2)}</Text>;
  }

  if (fileInfo === "type") {
    return <Text color="text-weak">{file.type}</Text>;
  }

  return null;
}
